import * as bootstrap from "bootstrap";

export default function (): void {
    // Enable tooltips, see https://getbootstrap.com/docs/5.3/components/tooltips/#enable-tooltips
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
        new bootstrap.Tooltip(element);
    });
}